import { Link } from "react-router-dom"
import {
  useTheme,
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Modal,
  Typography,
  IconButton,
} from "@mui/material"
import qs from "qs"

import { useTranslation } from "providers/i18n"
import { CallButton, CloseIconButton } from "components/Button"
import { LanguageSelector } from "components/Sidebar"
import { ContactIcon, PhoneIcon } from "../icons"
import { useState } from "react"
import { CloseIcon } from "components/icons"
import { useContact } from "extensions/bitec-buri/hooks/contact/useContact"

export const Sidebar = ({
  navigations = [],
  onClose = () => {},
  open = false,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const logo = theme.assets?.[`sidebarLogo`] || theme.assets?.[`logo`]

  const { styleOverrides = {} } = theme.components[`AppSidebar`]
  const {
    root,
    header,
    closeButton,
    body,
    footer,
    footerLogo,
    navList,
    navListItem,
    navDivider,
    navListWrapper,
    languageSelectorWrapper,
    helpCenterContainer,
    modalContainer,
    modalContent,
    modalCloseButton,
    contactContainer,
    descriptionContainer,
    descriptionText,
    callButton,
  } = styleOverrides

  const [isModalOpen, setModalOpen] = useState(false)
  const handleOpenModal = () => setModalOpen(true)
  const handleCloseModal = () => setModalOpen(false)
  const { helpCentre } = useContact()

  return (
    <Drawer
      open={open}
      onClose={onClose}
      anchor="left"
      PaperProps={{ sx: root }}
    >
      <CloseIconButton sx={closeButton} onClick={onClose} />

      {/** Header */}
      <Box sx={header}></Box>

      {/** Body */}
      <Box sx={body}>
        {/** Navigation */}
        <List sx={navList} disablePadding>
          {navigations.map((nav, index) => (
            <Box key={nav.to} sx={navListWrapper}>
              <ListItemButton
                component={Link}
                to={`${nav.to}?${qs.stringify(nav.qs)}`}
                sx={navListItem}
              >
                {nav.icon && <ListItemIcon>{nav.icon}</ListItemIcon>}
                {/* //i18n translation fallback */}
                <ListItemText
                  primary={t([`navigation.${nav.label}`, nav.label])}
                />
              </ListItemButton>
              <Divider sx={navDivider} />
            </Box>
          ))}
          <Box sx={helpCenterContainer}>
            <ListItemButton sx={navListItem} onClick={handleOpenModal}>
              <ListItemIcon>
                <ContactIcon />
              </ListItemIcon>
              <ListItemText primary={t("Help Centre")} />
            </ListItemButton>
            <Divider sx={navDivider} />
          </Box>
          <Box sx={languageSelectorWrapper}>
            <LanguageSelector onSwitchedLanguage={onClose} />
          </Box>
        </List>
      </Box>

      {/** Modal */}
      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <Box sx={modalContainer}>
          <Box sx={modalContent}>
            <Typography variant="h6">{t("Help Centre")}</Typography>
            <IconButton onClick={handleCloseModal} sx={modalCloseButton}>
              <CloseIcon />
            </IconButton>
            <Box sx={descriptionContainer}>
              <Typography sx={descriptionText}>
                {t(helpCentre?.descriptions)}
              </Typography>
            </Box>
            <Box sx={contactContainer}>
              {helpCentre.contacts.map((phoneNumber, index) => (
                <CallButton
                  phoneNumber={phoneNumber}
                  key={index}
                  startIcon={<PhoneIcon />}
                  label={phoneNumber}
                  sx={callButton}
                />
              ))}
            </Box>
          </Box>
        </Box>
      </Modal>

      {/** Footer */}
      <Box sx={footer}>
        {logo && (
          <Box sx={footerLogo}>
            <img src={logo.url} alt={logo.caption} />
          </Box>
        )}
      </Box>
    </Drawer>
  )
}
